import { MultiMaterialCompositeDto } from 'src/app/data-transfer/entities/material-entities/multi-material-composite-dto';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ADD_WITHOUT_TRACKING, ADD_WITH_TRACKING } from '../selection-dialog-components/selection-dialog-components.component';
import { MaterialApiService } from 'src/app/data-transfer/services/material-api-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogActions } from 'src/app/model/dictionary';
import { MultiMaterialLayerDto } from 'src/app/data-transfer/entities/material-entities/multi-material-layer-dto';
import { firstValueFrom } from 'rxjs';
import { CompositeMaterialsOverviewComponent } from '../../directory-tree/components/composite-materials-overview/composite-materials-overview.component';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';
import { CompositeMaterialSevice } from 'src/app/services/material-services/composite-material-service';

export interface FlatMaterialLayersList {
  materialId: number;
  allMaterialLayers: MultiMaterialLayerDto[];
}

export interface MultiMaterialCompositeImportWrapper extends MultiMaterialCompositeDto {
  isValidForComponent: boolean;
}

@Component({
  selector: 'app-selection-dialog-materials',
  templateUrl: './selection-dialog-materials.component.html',
  styleUrls: ['./selection-dialog-materials.component.scss']
})
export class SelectionDialogMaterialsComponent implements OnInit {

  @ViewChild('materialsTable') materialsTable!: CompositeMaterialsOverviewComponent;

  dataSource: PaginationDataSource<MultiMaterialCompositeImportWrapper>;
  displayedColumns!: string[];
  callerId!: number;
  packagingUnitTypeId!: number;
  isDataExchangeSubRequest = false;

  constructor(
    protected dialogRef: MatDialogRef<SelectionDialogMaterialsComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    private materialApiService: MaterialApiService
  ) {
    this.dataSource = new PaginationDataSource<MultiMaterialCompositeImportWrapper>(x => this.materialApiService.getMultiMaterialsByPage(x));
    if (data) {
      this.displayedColumns = data.displayedColumns;
      this.callerId = data.callerId;
      this.packagingUnitTypeId = data.packagingUnitTypeId;
      this.isDataExchangeSubRequest = data.isDataExchangeSubRequest;
    }
  }

  ngOnInit() {
    this.setValidityForComponent();
  }

  private async setValidityForComponent() {
    const flatMaterialsList: FlatMaterialLayersList[] = [];
    this.dataSource.data.forEach(x => {
      if (x.id == null) { return; }
      const allMaterialLayers = CompositeMaterialSevice.getMaterialLayersRecursively(x);
      flatMaterialsList.push({ materialId: x.id, allMaterialLayers });
    });

    for (const material of this.dataSource.data) {
      const flatMaterialEntry = flatMaterialsList.find(x => x.materialId === material.id);
      if (!flatMaterialEntry) { continue; }
      for (const materialLayer of flatMaterialEntry.allMaterialLayers) {
        if (materialLayer.functionId == null || materialLayer.materialId == null) { continue; }
        const validMaterials = await firstValueFrom(this.materialApiService.getValidMaterials(
          materialLayer.functionId, this.callerId, this.packagingUnitTypeId));
        if (!validMaterials.map(x => x.id).includes(materialLayer.materialId)) {
          material.isValidForComponent = false;
        }
      }
    }
  }

  importMaterials(withTracking: boolean) {
    let event: string;
    if (withTracking) {
      event = ADD_WITH_TRACKING;
    } else {
      event = ADD_WITHOUT_TRACKING;
    }
    this.dialogRef.close({ event, data: this.materialsTable.selectedMaterialIds });
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
